import React from 'react';
import { DateTime } from 'src_common/utils/time/time';
import { observer } from 'src/utils/mobx-react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import {
    CalendarIconWrapper,
    DateInputContainer,
    DatePickerStyled,
} from 'src/domains/layouts/shared/formComponents/dateInput/DateInputNew.style';

interface DateInputNewPropsType {
    stateValue: FormInputState<string, string>;
    selected?: string;
    placeholder?: string;
    label?: string;
    disabled?: boolean;
    dataTest?: string;
}

export const DateInputNew = observer(
    'DateInputNew',
    ({ stateValue, placeholder, label, disabled, selected, dataTest }: DateInputNewPropsType) => {
        const onChange = (date: Date): void => {
            const formattedDate = DateTime.from(date.toString())?.format('YYYY-MM-DD') ?? 'error';
            stateValue.setValue(formattedDate);
        };

        return (
            <>
                {label === undefined ? null : <InputLabel>{label}</InputLabel>}
                <DateInputContainer data-test={dataTest}>
                    <CalendarIconWrapper />
                    <DatePickerStyled
                        dateFormat='yyyy-MM-dd'
                        popperPlacement='top'
                        disabled={disabled ?? false}
                        placeholderText={placeholder}
                        selected={selected === undefined ? null : new Date(selected)}
                        value={stateValue.value}
                        onChange={onChange}
                    />
                </DateInputContainer>
            </>
        );
    }
);
